// redux/Overrides/actions.js

import {
    FETCH_OVERRIDES_SUCCESS,
    FETCH_OVERRIDES_FAILURE,
    FETCH_OVERRIDE_SUCCESS,
    FETCH_OVERRIDE_FAILURE,
    CREATE_OVERRIDE_SUCCESS,
    CREATE_OVERRIDE_FAILURE,
    UPDATE_OVERRIDE_SUCCESS,
    UPDATE_OVERRIDE_FAILURE,
    DELETE_OVERRIDE_SUCCESS,
    DELETE_OVERRIDE_FAILURE,
} from "./types";
import api from '../../config/base';

// Fetch all Overrides
export const fetchOverrides = () => async (dispatch) => {
    try {
        const response = await api.get("/overrides");
        dispatch({ type: FETCH_OVERRIDES_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({
            type: FETCH_OVERRIDES_FAILURE,
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Fetch a single Override
export const fetchOverride = (id) => async (dispatch) => {
    try {
        const response = await api.get(`/overrides/${id}`);
        dispatch({ type: FETCH_OVERRIDE_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({
            type: FETCH_OVERRIDE_FAILURE,
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Create an Override
export const createOverride = (overrideData) => async (dispatch) => {
    try {
        const response = await api.post("/overrides", overrideData);
        dispatch({ type: CREATE_OVERRIDE_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({
            type: CREATE_OVERRIDE_FAILURE,
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Update an Override
export const updateOverride = (id, overrideData) => async (dispatch) => {
    try {
        const response = await api.put(`/overrides/${id}`, overrideData);
        dispatch({ type: UPDATE_OVERRIDE_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({
            type: UPDATE_OVERRIDE_FAILURE,
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Delete an Override
export const deleteOverride = (id) => async (dispatch) => {
    try {
        await api.delete(`/overrides/${id}`);
        dispatch({ type: DELETE_OVERRIDE_SUCCESS, payload: id });
    } catch (error) {
        dispatch({
            type: DELETE_OVERRIDE_FAILURE,
            payload: error.response?.data?.message || error.message,
        });
    }
};
